// ！idNumberPass，phonePass 手机号验证是否通过（数据库不存在）
// ！useruuid 用户的uuid ，编辑时必须设置，否则保存会存在手机号重复的问题
// ！注意，打了这么多！，该注意了吧？重置表单的时候一定要把 idNumberPass，phonePass置空哈，否则再次验证就会直接通过，不再验证
// ！为啥加这两个烦人的字段？优化，让保存时，不在请求重复请求接口了，为啥不直接把 required 去掉？这样就不会 validate 验证中了，也就不会请求了。
// ！因为啊，没有前面必填的 * 了。 over，暂时没想到其他优化方案，至于接口中的 userUuid 根据新接口来定义，重置表单的时候要赋值为 undefined,编辑时必须传 useruuid
// ！
// ！
import common from '@/api/common'
import rules from './rules'
let formRules = {
  phone: [{
    required: true,
    validator: (rule, value, callback) => {
      if (!rules.phone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        if (formRules.phonePass === value) {
          callback()
        } else {
          common.checkPhone(value, formRules.userUuid).then(res => {
            if (res) {
              formRules.phonePass = value
              callback()
            } else {
              callback(new Error('该手机号已经被注册'))
            }
          })
        }
      }
    },
    trigger: 'blur'
  }],
  idNumber: [{
    required: true,
    validator: (rule, value, callback) => {
      if (!rules.idNumber(value)) {
        callback(new Error('请输入正确的身份证号'))
      } else {
        // 避免验证所有表单时，重复请求
        if (formRules.idNumberPass === value) {
          callback()
        } else {
          common.checkIdNumber(value, formRules.userUuid).then(res => {
            if (res) {
              formRules.idNumberPass = value
              callback()
            } else {
              callback(new Error('该身份证号已经被注册'))
            }
          })
        }
      }
    },
    trigger: 'blur'
  }],
  idName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
  position: [{ required: true, message: '请选择位置', trigger: 'change' }],
  squadUuid: [{ required: true, message: '请选择球队', trigger: 'change' }],
  unit: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
  idNumberPass: '',
  phonePass: '',
  testAddress: [{ required: true, message: '请输入测试地点', trigger: 'blur' }],
  linkMen: [{ required: true, message: '请输入测试联系人姓名', trigger: 'blur' }],
  testTime: [{ required: true, message: '请选择测试时间', trigger: 'change' }],
  linkMenPhone: [{
    required: true,
    validator: (rule, value, callback) => {
      if (!rules.phone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    },
    trigger: 'blur'
  }]
}

export default formRules
